exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".campaign-margin___fsbj4 {\n  margin-top: -70px;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/charityLogo.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;CACnB","file":"charityLogo.less","sourcesContent":[".campaign-margin {\n  margin-top: -70px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"campaign-margin": "campaign-margin___fsbj4"
};